// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Edit__pc_only___kMaLL","sp_only":"Edit__sp_only___2F3h2","container":"Edit__container___fPL_d"};